const baseApiPath = 'companies/:companyId/xero/counterparties';

export const paymentDetailsApiPaths = {
    counterparties: baseApiPath,
    counterpartyPaymentDetails: `${baseApiPath}/:counterpartyId/payment-details`,
    counterpartyPaymentDetailsById: `${baseApiPath}/:counterpartyId/payment-details/:paymentDetailsId`,
    requirements: `${baseApiPath}/payment-details/requirements`,
    validate: `${baseApiPath}/payment-details/validate`,
    verify: `${baseApiPath}/payment-details/verify`,
    paymentDetailsForBatchPayment: 'companies/:companyId/requests/:requestId/amax-pay/xero/payment-details',
    paymentDetailsForRequest:
        'companies/:companyId/requests/:requestId/xero/counterparties/:counterpartyId/payment-details',
    paymentDetailsForBill:
        'companies/:companyId/requests/:requestId/amax-pay/xero/bills/:billRequestId/payment-details/:paymentDetailsVersionId',
    checkPaymentDetails: 'companies/:companyId/requests/:requestId/amax-pay/xero/payment-details/check',
} as const;
